<div [hidden]="!isActive" class="myf-wizard-step"
	[ngClass]="{ 'myf-wizard-step--active': isActive, 'myf-wizard-step--complete': !isActive }">
	<ng-content></ng-content>
</div>